import Api from './ApiWAService'

// Etiquetas de organização das conversas do WhatsApp (CRUD + atribuição)
export default {
    list() {
        return Api().get('whatsapp_labels');
    },
    create({ name, color }) {
        return Api().post('whatsapp_labels', { name, color });
    },
    update(id, { name, color }) {
        return Api().put(`whatsapp_labels/${id}`, { name, color });
    },
    remove(id) {
        return Api().delete(`whatsapp_labels/${id}`);
    },
    // Todas as atribuições do tenant: [{ phone, WaLabelId }]
    assignments() {
        return Api().get('whatsapp_labels/assignments');
    },
    toggle(phone, labelId) {
        return Api().post('whatsapp_labels/assignments/toggle', { phone, labelId });
    },
}
